import React from "react"
import { CircularProgress, Container, Grid } from "@material-ui/core"
import ClearIcon from '@material-ui/icons/Clear'
import { Add } from "@material-ui/icons"
import searchStyles from '../AgentsComponent/styles.module.css'
import styles from './styles.module.css'
import { BlueInverseBtn } from "../Styled/StyledButtons"
import { IDestinationFilters } from "../../models/ExemptDestinations/ExemptDestination"

interface IProps {
    filters: IDestinationFilters
    searchStatus: string
    onChange: (filters: IDestinationFilters) => void
    onAdd: () => void
}

/**
 * Search and the removed-rows toggle.
 *
 * Removed entries are hidden by default and behind a toggle rather than dropped from the
 * screen: the reason a DID stopped being exempt is the second question anybody asks, and a
 * removed row still owns that number's whole history.
 */
const ControlPanel = (props: IProps) => {
    const set = (patch: Partial<IDestinationFilters>) => props.onChange({ ...props.filters, ...patch })

    return (
        <Container maxWidth={false}>
            <div className={styles.Warning}>
                A number on this list is exempt from <b>every</b> inbound spam filter — the
                robocall blocker, the blacklist, the Twilio add-on verdict, the potential-spam
                check, the regex rules and the carrier blocker. Keep it short.
            </div>
            <div className={styles.Panel}>
                <Grid container spacing={1} alignItems="flex-end">
                    <Grid item xs={12} md={4}>
                        <div className={searchStyles.filters__search}>
                            {props.searchStatus !== 'loading' ?
                                <span
                                    className={searchStyles.filters__search_clear}
                                    onClick={() => set({ q: '' })}>
                                    <ClearIcon className={searchStyles.filters__search_loading} />
                                </span>
                                :
                                <span className={searchStyles.filters__search_clear}>
                                    <CircularProgress size={24} className={searchStyles.filters__search_loading} />
                                </span>
                            }
                            <input
                                type="text"
                                placeholder="Search number or reason"
                                onChange={(e) => set({ q: e.target.value })}
                                value={props.filters.q || ''}
                                className={searchStyles.filters__search__inputSearch}
                            />
                        </div>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <label className={styles.Checkbox}>
                            <input
                                type="checkbox"
                                checked={!!props.filters.include_removed}
                                onChange={(e) => set({ include_removed: e.target.checked })}
                            />
                            &nbsp;Show removed
                        </label>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <BlueInverseBtn onClick={props.onAdd} variant="contained" fullWidth={true}>
                            <Add />&nbsp;Add number
                        </BlueInverseBtn>
                    </Grid>
                </Grid>
            </div>
        </Container>
    )
}

export default ControlPanel
